import { Divider, Flex } from "antd";
import React from "react";

export const ModalFooter: React.FunctionComponent<React.PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <>
      <Divider />
      <Flex gap={8} justify="flex-end">
        {children}
      </Flex>
    </>
  );
};

export default ModalFooter;
